import $ from '../core/Dom';
import Dispatch from '../core/Dispatch';
import Components from '../core/Components';

import { loadAxios } from '../lib/async-bundles';
import Viewport from '../core/Viewport';
import { FILTER_UPDATED, DOM_UPDATED } from '../lib/events';
import EcoMode from "../lib/EcoMode";

export default (el, props) => {
    const $el = $(el);
    const $body = $('body');
    const $paginationWrapper = $el.find('[data-pagination]');

    const { indexPageUrl, contentTypeLabel } = props;

    let Axios = null;

    let isLoading = false;
    let lastFilter = null;
    let hasUpdatedHistory = false;

    const init = () => {
        loadAxios(axios => {
            Axios = axios;

            $paginationWrapper.on('click', 'a', e => {
                e.preventDefault();
                e.stopImmediatePropagation();

                const $link = $(e.triggerTarget);

                newPage($link.attr('href'));
            });

            Dispatch.on(FILTER_UPDATED, onFilterUpdated);
        });

        window.history.replaceState({ reloadBack: true }, document.title);
    };

    const destroy = () => {
        Dispatch.off(FILTER_UPDATED, onFilterUpdated);
    };

    const onFilterUpdated = (e, data) => {
        doUpdate(data.filter);
    };

    const doUpdate = filter => {
        if (Axios === null) {
            console.error('Axios bundle not loaded');
            return;
        }

        const url = indexPageUrl + (filter !== '' ? (indexPageUrl.indexOf('?') !== -1 ? '&' : '?') + filter : '');
        
        load(url);

        lastFilter = filter;
    };

    const newPage = url => {
        if (isLoading) {
            return;
        }

        if (Axios === null) {
            console.error('Axios bundle not loaded');
            return;
        }
        
        load(url);
    };
    
    const load = url => {
        isLoading = true;
        $el.css({ opacity: 0.3, 'pointer-events': 'none' });
        
        Axios({
            method: 'get',
            url,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest', Accept: 'text/html' },
            validateStatus: status => status >= 200 && status < 400
        }).then(res => {
            const { status, data } = res || {};

            
            setTimeout(() => {
                if (status === 200 && data) {
                    insertData(data);
                    updateHistory(url);
                } else {
                    // Do something else
                }
    
                isLoading = false;
                
                $el.css({ opacity: 1, 'pointer-events': '' });
            }, 500);

        }).catch((error, res) => {
            console.log(error, res);
        });
    };
    

    const updateHistory = url => {
        if (window.history) {
            if (hasUpdatedHistory) {
                window.history.replaceState({ reloadBack: true }, document.title, url);
            } else {
                window.history.pushState({ reloadBack: true }, document.title, url);
            }

            hasUpdatedHistory = true;
        }
    };

    const insertData = (html, append, updateFilter) => {
        if ($paginationWrapper.length > 0) {
            $paginationWrapper.css({ opacity: '' });
        }

        const $newHtml = $(`<div>${html}</div>`);
        $newHtml.find('noscript').remove();

        const $newResult = $newHtml.find('[data-result]');
        const $newPaginationWrapper = $newHtml.find('[data-pagination]');
        const $newHeading = $newHtml.find('[data-result-page-heading]');
        // const $form = $newHtml.find('[data-filter-form]');
        const $resultWrapper = $el.find('[data-result]');


        if ($newResult.length > 0) {
            ensureResultInside();

            $resultWrapper.attr('class', $newResult.attr('class'));

            Components.destroy($resultWrapper);
            $resultWrapper.empty();

            // We do this before actually inserting them, to get to the items before they 
            // are detached from the $newResultsList DOM
            Dispatch.emit(DOM_UPDATED, { $markup: $newResult });

            // $resultSummary.text('Showing ' + count + ' ' + contentTypeLabel + ' in list.')
            $resultWrapper.append($newResult.get(0).children);
        } else {
            // TODO : Error?
        }

        if ($newPaginationWrapper.length > 0) {
            const $pagination = $el.find('[data-pagination]');
            $pagination.empty().append($newPaginationWrapper.get(0).children);
        }

        if ($newHeading.length > 0) {
            const $resultHeading = $el.find('[data-result-page-heading]');
            $resultHeading.empty().get(0).append(...$newHeading.get(0).childNodes);
        }
        
        $body.find('[data-filter-toggle-label]').each(toggle => {
            console.log('toggle', toggle);
            const $toggle = $(toggle);
            const $newToggleLabels = $newHtml.find('[data-filter-toggle-label="' + $toggle.attr('data-filter-toggle-label') + '"]');
            if ($newToggleLabels.length > 0) {
                $newToggleLabels.each(newToggle => {
                    console.log('newToggle', newToggle);
                    $toggle.empty();
                    newToggle.childNodes.forEach(node => {
                        $toggle.get(0).append(node.cloneNode(true));
                    });
                });
            }
        });

        /*
        if (updateFilter && $form.length > 0) {
            Dispatch.emit(FILTER_FORM_UPDATED, { $form });
        }
        */

        Components.init();
    };

    const ensureResultInside = () => {
        const $resultWrapper = $el.find('[data-result]');

        if ($resultWrapper.length === 0) return;

        const node = $resultWrapper.get(0);
        const rect = node.getBoundingClientRect();

        // If the top of the result wrapper is above the viewport, scroll up to it
        if (rect.top < 0) {
            const { top } = $resultWrapper.offset();
            let scrollMargin;

            try {
                scrollMargin = parseInt(window.getComputedStyle(node).getPropertyValue('scroll-margin-top') || 0, 10);
            } catch (error) {
                scrollMargin = 0;
            }

            window.scrollTo({ top: Math.max(top - scrollMargin - 100, 0) });
        }
    };

    return {
        init,
        destroy
    };

};
